"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Enum that is returned by the [[AbstractEvent.callListener]] method
 */
var CallListenerResult;

(function (CallListenerResult) {
  CallListenerResult[CallListenerResult["NONE"] = 0] = "NONE";
  CallListenerResult[CallListenerResult["PROPAGATION_STOPPED"] = 1] = "PROPAGATION_STOPPED";
  CallListenerResult[CallListenerResult["IMMEDIATE_PROPAGATION_STOPPED"] = 2] = "IMMEDIATE_PROPAGATION_STOPPED";
})(CallListenerResult || (CallListenerResult = {}));

var _default = CallListenerResult;
exports.default = _default;